import { ResourceApi } from '@fullcalendar/resource';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import { Button, Checkbox, Chip, colors, Stack, Tooltip, Typography } from '@mui/material';
import { FC, memo } from 'react';
import { CalendarResourceEntityWithChecked } from 'src/entities/CalendarResource.entity';
import { PlanningsDriverEntity } from 'src/entities/PlanningsDriver.entity';
import { PlanningsTruckEntity } from 'src/entities/PlanningsTruck.entity';

type Props = {
  resource: ResourceApi;
  res: CalendarResourceEntityWithChecked;
  someFixed: boolean;
  allFixed: boolean;
  tooltipTitle: string[];
  handleCheckboxChange: (event: React.ChangeEvent<HTMLElement>, resourceId: string) => void;
  handleTruckMenuOpen: (event: React.MouseEvent<HTMLButtonElement>, clickedTruckEntity: PlanningsTruckEntity) => void;
  handleDriverMenuOpen: (event: React.MouseEvent<HTMLButtonElement>, clickedDriverEntity: PlanningsDriverEntity) => void;
  handleTruckLabelClick: (event: React.MouseEvent<HTMLElement>, resourceId: string) => void;
};

const ResourceStackMemo: FC<Props> = memo(({
  resource,
  res,
  someFixed,
  allFixed,
  tooltipTitle,
  handleCheckboxChange,
  handleTruckMenuOpen,
  handleDriverMenuOpen,
  handleTruckLabelClick,
}) => (
  <Stack
    direction="row"
    alignItems="center"
    justifyContent="space-between"
    alignContent="space-between"
  >
    <Stack direction="row" alignItems="center">
      <Checkbox
        checked={res.isChecked}
        onClick={(event) => {
          // クリックイベントの伝播を停止
          event.stopPropagation();
        }}
        onChange={(event) => handleCheckboxChange(event, resource.id)}
        style={{ marginRight: 8 }}
      />
      <Button sx={{ p: 0, m: 0, }} onClick={(event) => handleTruckMenuOpen(event, res.truckEntity)} disabled={someFixed}>
        <Typography
          variant="h5"
          sx={{ color: (!someFixed && res.truckEntity.temporary) ? '#E65100' : '' }}
        >
          {res.truckEntity.temporary ? '指定なし' : res.truckEntity.licensePlateValue}
        </Typography>
        <ArrowDropDownIcon />
      </Button>
      <Typography sx={{ mx: 1 }}>/</Typography>
      <Button sx={{ p: 0, m: 0, }} onClick={(event) => handleDriverMenuOpen(event, res.driverEntity)} disabled={someFixed}>
        <Typography
          variant="h5"
          sx={{ color: (!someFixed && res.driverEntity.temporary) ? '#E65100' : '' }}
        >
          {res.driverEntity.temporary ? '指定なし' : res.driverEntity.name}
        </Typography>
        <ArrowDropDownIcon />
      </Button>
    </Stack>
    <Stack direction="row" alignItems="center">
      {allFixed && (
        <Chip color="info" size="small" label="全確定" />
      )}
      {!allFixed && someFixed && (
        <Chip color="info" size="small" label="一部確定" />
      )}
      {res.hasWarning && (
        <Tooltip title={tooltipTitle}>
          <WarningAmberRoundedIcon color="error" fontSize="small" sx={{ p: 0, m: 0, }} />
        </Tooltip>
      )}
      <Stack
        sx={{ ml: 1, cursor: 'pointer' }}
        direction="row"
        onClick={(event) => handleTruckLabelClick(event, resource.id)}
      >
        <InfoOutlinedIcon sx={{ color: colors.blue[900] }} />
      </Stack>
    </Stack>
  </Stack>
));

export default ResourceStackMemo;
